__turbopack_context__.v({
  "active-index": "search-module-scss-module__Ago2Jq__active-index",
  "calculator": "search-module-scss-module__Ago2Jq__calculator",
  "date": "search-module-scss-module__Ago2Jq__date",
  "form": "search-module-scss-module__Ago2Jq__form",
  "headline": "search-module-scss-module__Ago2Jq__headline",
  "page-indexes": "search-module-scss-module__Ago2Jq__page-indexes",
  "placeholder": "search-module-scss-module__Ago2Jq__placeholder",
  "result": "search-module-scss-module__Ago2Jq__result",
  "result-count": "search-module-scss-module__Ago2Jq__result-count",
  "result-count-placeholder": "search-module-scss-module__Ago2Jq__result-count-placeholder",
  "result-list": "search-module-scss-module__Ago2Jq__result-list",
  "result-list-placeholder": "search-module-scss-module__Ago2Jq__result-list-placeholder",
  "result-text": "search-module-scss-module__Ago2Jq__result-text",
  "rich-text": "search-module-scss-module__Ago2Jq__rich-text",
  "rich-text-container": "search-module-scss-module__Ago2Jq__rich-text-container",
  "rich-text-ul": "search-module-scss-module__Ago2Jq__rich-text-ul",
  "search-input": "search-module-scss-module__Ago2Jq__search-input",
  "section": "search-module-scss-module__Ago2Jq__section",
  "start": "search-module-scss-module__Ago2Jq__start",
});
